import MyLeads from './MyLeads';

export default function Dashboard() {
  return (
    <div>
      <MyLeads />
    </div>
  );
}
